
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("2Wlt9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "EndOfTrialExtension", () => $0bc9e705da2321c9$export$247b969e5bf0820b);
$parcel$export(module.exports, "default", () => $0bc9e705da2321c9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ln6Iy = parcelRequire("ln6Iy");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $eWzpp = parcelRequire("eWzpp");

var $8vyDv = parcelRequire("8vyDv");

var $kEUB1 = parcelRequire("kEUB1");

var $9HmCl = parcelRequire("9HmCl");

var $dY3rz = parcelRequire("dY3rz");

var $5tQVZ = parcelRequire("5tQVZ");

var $7jTnu = parcelRequire("7jTnu");

var $4BHJn = parcelRequire("4BHJn");

var $b1OaF = parcelRequire("b1OaF");
const $0bc9e705da2321c9$export$247b969e5bf0820b = ()=>{
    const { data: project } = (0, $eWzpp.useProject)();
    const projectType = (0, $ln6Iy.toProjectType)(project?.type);
    const appEditions = (0, $8vyDv.useAppEditions)();
    const productEntitlementDetails = (0, $9HmCl.useProductEntitlementDetails)();
    const productKey = projectType && (0, $ln6Iy.projectTypeToCanonicalId)(projectType);
    const entitlementDetails = productKey && productEntitlementDetails?.[productKey];
    const billingSourceSystem = entitlementDetails?.billingSourceSystem;
    const trialDaysLeft = (0, $5tQVZ.useMemoizedTrialDaysLeftFromTrialEndTime)(entitlementDetails?.trialEndTime) ?? 0;
    const shouldLoadEntryPoint = (0, $4BHJn.isProjectTypeAndEditionSupported)(appEditions, project?.type) && billingSourceSystem === 'CCP' && (0, $4BHJn.isStartOfTrial)(trialDaysLeft);
    const { entryPointReferenceSubject: entryPointReferenceSubject } = $0bc9e705da2321c9$var$useCoordinatorEntryPoint(shouldLoadEntryPoint);
    if (!shouldLoadEntryPoint) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dY3rz.ContextWrapper), {
        attributes: {
            trialDaysLeft: trialDaysLeft,
            growthInitiative: 'buy'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "growth.endOfTrialExtension.coordinator",
        packageName: "jira-end-of-trial-extension",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: {
            trialDaysLeft: trialDaysLeft
        }
    }));
};
var $0bc9e705da2321c9$export$2e2bcd8739ae039 = $0bc9e705da2321c9$export$247b969e5bf0820b;
const $0bc9e705da2321c9$var$useCoordinatorEntryPoint = (shouldLoad)=>{
    const cloudID = (0, $kEUB1.useCloudId)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudID,
            isTwcJiraTouchPointFix: (0, $7jTnu.fg)('twc_jira_touchpoint_fix')
        }), [
        cloudID
    ]);
    const hasLoadedEntrypoint = (0, $eJOHy.useRef)(false);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $b1OaF.endOfTrialExtensionCoordinatorEntryPoint), entryPointParams);
    if (!hasLoadedEntrypoint.current && shouldLoad) {
        entryPointActions.load();
        hasLoadedEntrypoint.current = true;
    }
    return {
        entryPointReferenceSubject: entryPointReferenceSubject
    };
};

});
parcelRegister("dY3rz", function(module, exports) {

$parcel$export(module.exports, "ContextWrapper", () => $a310c342dd42ad78$export$34282a1f95511a11);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6dPbw = parcelRequire("6dPbw");

var $4lYQk = parcelRequire("4lYQk");

var $e2B2h = parcelRequire("e2B2h");
const $a310c342dd42ad78$export$dc30f43798194b03 = (props)=>{
    const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
    const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4lYQk)))({
        source: source,
        ...rest
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6dPbw))));
};
const $a310c342dd42ad78$export$34282a1f95511a11 = (props)=>{
    const data = $a310c342dd42ad78$export$dc30f43798194b03(props);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
        data: data,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: props.children
        })
    });
};

});

parcelRegister("4BHJn", function(module, exports) {

$parcel$export(module.exports, "isProjectTypeAndEditionSupported", () => $6ccc8ded9783b843$export$c9a5a2a3868318aa);
$parcel$export(module.exports, "isStartOfTrial", () => $6ccc8ded9783b843$export$3ed802a9182778d3);
$parcel$export(module.exports, "getEpMessageId", () => $6ccc8ded9783b843$export$6d238e51ec3581ff);

var $ln6Iy = parcelRequire("ln6Iy");

var $a9ldn = parcelRequire("a9ldn");
const $6ccc8ded9783b843$export$c9a5a2a3868318aa = (applicationEditions, project)=>{
    const projectType = (0, $ln6Iy.toProjectType)(project);
    if (!projectType || projectType !== (0, $ln6Iy.SOFTWARE_PROJECT)) return false;
    return applicationEditions.software === (0, $a9ldn.STANDARD_EDITION);
};
const $6ccc8ded9783b843$export$3ed802a9182778d3 = (daysLeft)=>daysLeft >= 8 && daysLeft <= 13;
const $6ccc8ded9783b843$export$6d238e51ec3581ff = (daysLeft)=>{
    if (daysLeft >= 11 && daysLeft <= 13) return 'prj-end-of-trial-extension-message-1';
    if (daysLeft >= 8 && daysLeft <= 10) return 'prj-end-of-trial-extension-message-2';
    return null;
};

});

parcelRegister("b1OaF", function(module, exports) {

$parcel$export(module.exports, "endOfTrialExtensionCoordinatorEntryPoint", () => $d3a005e4955490d4$export$a9d3ae8f5b103f);

var $hG5cu = parcelRequire("hG5cu");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $d3a005e4955490d4$export$a9d3ae8f5b103f = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("dkd2O")), {
        moduleId: "52e3b20a",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, isTwcJiraTouchPointFix: isTwcJiraTouchPointFix })=>({
            entryPoints: {},
            queries: {
                billingAdminQuery: {
                    parameters: (0, $hG5cu.default),
                    variables: {
                        cloudId: cloudId,
                        isTwcJiraTouchPointFix: isTwcJiraTouchPointFix
                    }
                }
            }
        })
});

});
parcelRegister("hG5cu", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e631790864b9719$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<272120c27524e95b9f6ad4726c1247c8>>
 * @relayHash bebb1374303a6344b6c6b1854752f440
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4977ff928289c935ac9557ae1cdfc3e1a41321e9efd62196553dd455dc88c4e6
const $3e631790864b9719$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4977ff928289c935ac9557ae1cdfc3e1a41321e9efd62196553dd455dc88c4e6",
        "metadata": {},
        "name": "uiExperimentCoordinatorEndOfTrialExtensionQuery",
        "operationKind": "query",
        "text": null
    }
};
var $3e631790864b9719$export$2e2bcd8739ae039 = $3e631790864b9719$var$node;

});

parcelRegister("dkd2O", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6RqzI").then(()=>parcelRequire('eH0aK'));

});




//# sourceMappingURL=end-of-trial-extension.f0f3fbc0.js.map
